import React from 'react';
import { Helmet } from 'react-helmet';

const Blog = () => {
  const newsData = [
    {
      title: "Mumbai to Shirdi cab service",
      category: "S9 Travels: Affordable and comfortable Mumbai to Shirdi cab service for your spiritual journey. Enjoy a hassle-free ride with experienced drivers and well-maintained vehicles. Book now for a smooth trip to one of Maharashtra's most popular pilgrimage destinations.",
      date: "20 Mar, 2023",
      imgSrc: "/images/keyword/48.jpg",
      link: "/Mumbai-to-Shirdi-cab-service"
    },
    {
      title: "Mumbai to 5 Jyotirlinga Darshan ",
      category: "S9 Travels: Mumbai to 5 Jyotirlinga Darshan Cab Service. Enjoy a divine journey with our affordable and hassle-free Mumbai to 5 Jyotirlinga Darshan cab service. Relax in comfort as our professional drivers ensure a smooth and spiritual trip to the temples.",
      date: "20 Mar, 2023",
      imgSrc: "/images/keyword/80.jpg",
      link: "/Mumbai-to-5-Jyotirlinga-Darshan-cab"
    },
    {
      title: "Mumbai to Bhimashankar cab",
      category: "S9 Travels: Best Mumbai to Bhimashankar cab options for a hassle-free journey. Experience a smooth ride with experienced drivers, comfortable vehicles, and scenic views to Bhimashankar, a serene and sacred destination.",
      date: "20 Mar, 2023",
      imgSrc: "/images/keyword/49.jpg",
      link: "/Mumbai-to-Bhimashankar-Cab"
    },
    {
      title: "Pune to Ashtavinayak Cab Service",
      category: "S9 Travels: Affordable Pune to Ashtavinayak Cab Service for a Memorable Trip. Sit back and relax while we take care of your journey with our professional drivers and comfortable vehicles to ensure you enjoy every moment of the ride.",
      date: "20 Mar, 2023",
      imgSrc: "/images/keyword/31.jpg",
      link: "/Pune-To-Ashtavinayak-Cab-Service"
    },
    {
      title: "Mumbai to Goa cab",
      category: "S9 Travels: Reliable Mumbai to Goa cab services with great comfort. Whether you're heading for a vacation or a business trip, we ensure a smooth and comfortable journey with experienced drivers and well-maintained vehicles.",
      date: "20 Mar, 2023",
      imgSrc: "/images/keyword/50.jpg",
      link: "/Mumbai-to-Goa-cab"
    },
    {
      title: "Navi Mumbai to Goa cab",
      category: "S9 Travels: Affordable Navi Mumbai to Goa cab services for a memorable trip. Sit back and relax while we take care of your journey with our professional drivers and comfortable vehicles to ensure you enjoy every moment of the ride.",
      date: "20 Mar, 2023",
      imgSrc: "/images/keyword/51.jpg",
      link: "/Navi-Mumbai-to-Goa-cab"
    },
    {
      title: "Mumbai to Kolhapur cab",
      category: "S9 Travels: Convenient Mumbai to Kolhapur cab services for your journey. Experience comfort, safety, and professional drivers while traveling to Kolhapur, known for its historic temples and delectable food.",
      date: "20 Mar, 2023",
      imgSrc: "/images/keyword/52.jpg",
      link: "/Mumbai-to-Kolhapur-cab"
    },
    {
      title: "Mumbai Airport cab",
      category: "S9 Travels: Book your comfortable Mumbai Airport cab for a smooth arrival. Whether you're arriving for a business trip or vacation, S9 Travels ensures timely pickups and a comfortable ride to your destination.",
      date: "20 Mar, 2023",
      imgSrc: "/images/keyword/53.jpg",
      link: "/Mumbai-Airport-cab"
    },
    {
      title: "Mumbai to Konkan Darshan Cab",
      category: "S9 Travels: Mumbai to Konkan Darshan Cab Service. Travel comfortably from Mumbai to Konkan with our affordable and hassle-free service. Enjoy a smooth ride with professional drivers and well-maintained vehicles.",
      date: "20 Mar, 2023",
      imgSrc: "/images/keyword/56.jpg",
      link: "/Mumbai-to-Konkan-Darshan"
    },
  ];
  
  
  
  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Pune to Mumbai Cab",
    "description": "Book your comfortable Pune to Mumbai cab for a smooth and hassle-free journey. Choose from one-way, round trip, and group travel options with both affordable and luxury cabs.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "450"
    }
  };

  return (
    <>

          <Helmet>
              <title>Pune to Mumbai Cab | S9 Travels | Contact: +91 8850328441</title>
              <meta 
                name="description" 
                content="Book a reliable cab for your Pune to Mumbai journey. Affordable and luxury cabs available for one-way, round-trip, and group travel services." 
              />
              {/* Inject JSON-LD Schema */}
              <script type="application/ld+json">
                {JSON.stringify(productSchema)}
              </script>
            </Helmet>
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>Blog</h1>
        </div>
      </div>
    </section>

    <section className="news-section blog-grid pt_120 pb_120">
      <div className="auto-container">
        <div className="row clearfix">
          {newsData.map((news, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-12 news-block">
              <div className="news-block-one wow fadeInUp animated" data-wow-delay={`${index * 300}ms`} data-wow-duration="1500ms">
                <div className="inner-box borderr p-2">
                  <figure className="image-box ">
                    <a href={news.link}>
                      <img src={news.imgSrc} alt={news.title} />
                    </a>
                  </figure>
                  <div className="lower-content  py-5">
                    <ul className="post-info mb_15">
                     
                    </ul>
                    <h3><a className='darkcolorrr'>{news.title}</a></h3>
                    <p className='text-white'>{news.category}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
    </>
  );
}

export default Blog;
